import { render } from "./GridPromoTilesCollection.vue?vue&type=template&id=177a7e6e&scoped=true"
import script from "./GridPromoTilesCollection.vue?vue&type=script&lang=js"
export * from "./GridPromoTilesCollection.vue?vue&type=script&lang=js"

import "./GridPromoTilesCollection.vue?vue&type=style&index=0&id=177a7e6e&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177a7e6e"]])

export default __exports__